module.exports = __webpack_public_path__ + "img/DE00933.2b1459ad.png";